module.exports = __webpack_public_path__ + "static/media/icon_statement-generator.0dac3407.svg";